import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MarcacaoConsulta } from '../marcacao/marcacao-consulta/marcacao-consulta';
import { Marcacao } from '../marcacao/marcacao-procedimento/marcacao';
import { AbstractServicePublic } from '../service/abstract.service.public';

@Injectable({
  providedIn: 'root'
})
export class ServicosUtilidadesService extends AbstractServicePublic {

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'utilidades';
  }

  getDataAtual(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/getDataAtual`);
  }

  enviarEmailAgendamentoConsulta(marcacaoConsulta: MarcacaoConsulta, emailPaciente: string): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPublic()}/enviarEmailAgendamento/consulta/${emailPaciente}`, marcacaoConsulta);
  }

  enviarSMSAgendamentoConsulta(marcacaoConsulta: MarcacaoConsulta, fonePaciente: string): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPublic()}/enviarSMSAgendamento/consulta/${fonePaciente}`, marcacaoConsulta);
  }

  enviarEmailAgendamentoProcedimento(marcacaoProcedimento: Marcacao, emailPaciente: string, appAlias: string, local: string): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPublic()}/enviarEmailAgendamento/procedimento/${emailPaciente}/${appAlias}/${local}`, marcacaoProcedimento);
  }

  enviarSMSAgendamentoProcedimento(marcacaoProcedimento: Marcacao, fonePaciente: string, appAlias: string, local: string): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPublic()}/enviarSMSAgendamento/procedimento/${fonePaciente}/${appAlias}/${local}`, marcacaoProcedimento);
  }

}
